import './styles/component.inpage-search.scss';
import { _qs, _qsa, _on, _data } from '../js/shortJS';
import { isNullOrUndef } from '../js/helpers/isNullOrUndef';
import { isNotNullOrUndef } from '../js/helpers/isNotNullOrUndef';
class ComponentInpageSearch extends HTMLElement {
    input = null;
    searchableItemsKey;
    searchableItems = [];
    noResultElement;
    searchDelay;
    constructor() {
        super();
        this.searchableItemsKey = this[_data].searchableItemsKey;
        const delay = this[_data].searchDelay;
        this.searchDelay = isNotNullOrUndef(delay) ? parseInt(delay) : 300;
    }
    connectedCallback() {
        this.input = this[_qs]('input[type="search"]');
        this.searchableItems = isNotNullOrUndef(this.searchableItemsKey)
            ? document[_qsa](`[data-searchable-item-key=${this.searchableItemsKey}]`)
            : [];
        this.noResultElement = this.createNoResultEl();
        this.init();
    }
    init() {
        if (isNullOrUndef(this.input))
            return;
        const input = this.input;
        const inputPlaceholder = input.placeholder;
        let timeout = 0;
        input[_on]('input', () => {
            window.clearTimeout(timeout);
            timeout = window.setTimeout(() => {
                this.search(input.value.toLowerCase());
            }, this.searchDelay);
        });
        input[_on]('focus', () => {
            if (input.value !== '')
                return;
            input.placeholder = '';
        });
        input[_on]('blur', () => {
            if (input.value !== '' || input.placeholder === inputPlaceholder)
                return;
            input.placeholder = inputPlaceholder;
        });
    }
    search(query) {
        isNotNullOrUndef(this.noResultElement) && (this.noResultElement.hidden = true);
        let countOfVisibleElements = 0;
        for (const item of this.searchableItems) {
            const itemDataSearchValue = item[_data].searchValue;
            if (isNullOrUndef(itemDataSearchValue))
                return;
            let itemHidden = !itemDataSearchValue.includes(query);
            const subItems = item[_qsa]('[data-searchable-sub-item]');
            if (subItems.length > 0) {
                let visibleSubItemsCounter = 0;
                for (const subItem of subItems) {
                    if (!itemHidden) {
                        subItem.hidden = false;
                        continue;
                    }
                    const subItemDataSearchValue = subItem[_data].searchValue;
                    if (isNullOrUndef(subItemDataSearchValue))
                        return;
                    subItem.hidden = !subItemDataSearchValue.includes(query);
                    !subItem.hidden && ++visibleSubItemsCounter;
                }
                if (visibleSubItemsCounter > 0)
                    itemHidden = false;
            }
            item.hidden = itemHidden;
            !item.hidden && countOfVisibleElements++;
        }
        countOfVisibleElements === 0 &&
            isNotNullOrUndef(this.noResultElement) &&
            (this.noResultElement.hidden = false);
        const searchEvent = new CustomEvent('search', { detail: { query } });
        this.dispatchEvent(searchEvent);
    }
    createNoResultEl() {
        const searchableItemFirst = this.searchableItems[0];
        const searchableItemsParent = searchableItemFirst.parentElement;
        const noResultMsgEl = searchableItemFirst.cloneNode();
        noResultMsgEl[_data].searchValue = '';
        noResultMsgEl[_data].noResult = '';
        noResultMsgEl.hidden = true;
        noResultMsgEl.innerHTML = '<div class="text:center">Nothing found</div>';
        if (isNullOrUndef(searchableItemsParent))
            return;
        searchableItemsParent.append(noResultMsgEl);
        return noResultMsgEl;
    }
}
customElements.define('inpage-search-component', ComponentInpageSearch);
